import { useState } from 'react';
import { getResearchPdfCover } from '../../services/researchCover';
import { detectMediaKind, type ResearchEntry } from '../../services/researchApi';

export function ResearchCover({ entry, className = '' }: {
  entry: ResearchEntry;
  className?: string;
}) {
  const [failed, setFailed] = useState<string[]>([]);
  const explicit = entry.cover_image_url?.trim();
  const pdf = getResearchPdfCover(entry.research_documentation_url);
  const source = explicit && !failed.includes(explicit)
    ? explicit
    : pdf && !failed.includes(pdf) ? pdf : undefined;
  const isPdf = source === pdf;
  const onError = () => { if (source) setFailed(previous => [...previous, source]); };

  if (!source) return (
    <span className="text-white/70 text-sm font-semibold text-center">
      {entry.header || 'Research documentation'}
    </span>
  );

  if (!isPdf && detectMediaKind(source) === 'video') return (
    <video key={source} src={source} autoPlay loop muted playsInline preload="metadata"
      aria-label={entry.header || 'Research cover'} className={className} onError={onError} />
  );

  return (
    <img key={source} src={source} loading="lazy" decoding="async" onError={onError}
      alt={isPdf ? `${entry.header || 'Research documentation'} — PDF first page` : entry.header || 'Research cover'}
      className={`${className}${isPdf ? '' : ' filter invert brightness-0'}`} />
  );
}
